<template>
  <div :class="readOnlyProp?'btn-group display-only' : 'btn-group' " style="margin:0" data-toggle="buttons">
    <label class="btn btn-default"
           :disabled="readOnlyProp || null"
           @click="updateValue('Y')"
           :class="{'active': isYes}">
      <input type="radio" value="Y"
             :checked="!readOnlyProp && isYes"/> Yes
    </label>
    <label class="btn btn-default"
           :disabled="readOnlyProp || null"
           @click="updateValue('N')"
           :class="{'active': modelValue === 'N'}">
      <input type="radio" value="N"
             :checked="!readOnlyProp && modelValue === 'N'"/> No
    </label>
    <label class="btn btn-default"
           :disabled="readOnlyProp || null"
           @click="updateValue('')"
           :class="{'active': isNA}">
      <input type="radio" value=""
             :checked="!readOnlyProp && isNA"/> N/A
    </label>
  </div>
</template>

<script>
  export default {
    emits: ['update:modelValue','change'],
    name: 'yes-no-na-input',

    props: {
      modelValue: { default: null },
      readOnlyProp: Boolean
    },
    computed: {
      isYes () {
        return this.modelValue === 'Y'
      },
      isNA () {
        return this.modelValue === null || this.modelValue === ''
      }
    },
    methods: {
      updateValue (value) {
        if (this.readOnlyProp) {
          return
        }
        this.$emit('update:modelValue', value)
        this.$emit('change', value)
      }
    }
  }
</script>

<style scoped>
  .btn-default.active, .btn-default.active.focus, .btn-default.active:hover, .btn-default:active, .btn-default:hover, .open>.btn-default.dropdown-toggle {
    color: #fff;
    background-color: #337ab7;
    border-color: #2e6da4;
  }

  .btn-group.display-only label.btn {
    pointer-events: none;
    cursor: not-allowed;
  }

  .btn-group.display-only label.btn.active {
    opacity: 1;
    color: #ffffff;
    background-color: #c3c1c1;
    border-color: #adadad;
    -webkit-box-shadow: inset 0 3px 5px rgba(234, 152, 152, 0.12);
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.12);
  }
</style>
